import React, { Suspense } from "react"
import {
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom"

import ApplicationLayout from "layouts/application"
import MainLayout from "layouts/main"
import ActionHistory from "pages/action-history"
import Home from "pages/home"
import Login from "pages/login"
import { OCR } from "pages/ocr"
import GroupMain from "layouts/application-group/pages/main"
import GroupResult from "layouts/application-group/pages/result"
import Client from "layouts/application-group/pages/client"
import GroupOcr from "layouts/application-group/pages/ocr"
import GroupScoring from "layouts/application-group/pages/scoring"
import Result from "pages/result"
import Scoring from "pages/scoring"
import Settings from "pages/settings"
import Users from "pages/users"
import request from "request"
import { useDispatch, useSelector } from "store/hooks"
import HomeSingleLoans from "pages/home-single-loan"
import HomeGroupLoans from "pages/home-group-loans"
import ApplicationGroupLayout from "layouts/application-group"

const AppRoutes: React.FC = (): JSX.Element => {
  const location = useLocation()
  const [access, setAccess] = React.useState(false)
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const user = useSelector((state) => state.user)

  React.useEffect(() => {
    const handleGetValidToken = async () => {
      const response = await request.get("validate_token")
      if (response.status === 200) {
        setAccess(true)
        dispatch.user.SET(response.data)
      } else {
        setAccess(false)
      }
    }
    if (location.pathname !== "/login") {
      handleGetValidToken()
    } else setAccess(false)
  }, [dispatch, location.pathname, navigate])

  return (
    <Suspense fallback="Loading">
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={access ? <MainLayout /> : <></>}>
          <Route element={<Home />}>
            <Route path="/" element={<HomeSingleLoans />} />
            <Route path="/group-loans" element={<HomeGroupLoans />} />
          </Route>

          <Route path="/application" element={<ApplicationLayout />}>
            <Route path="/application/:id/result" element={<Result />} />
            <Route path="/application/:id/scoring" element={<Scoring />} />
            <Route path="/application/:id/ocr" element={<OCR />} />
          </Route>

          <Route path="/application-group" element={<ApplicationGroupLayout />}>
            <Route path="/application-group/:id" element={<GroupMain />} />
            <Route
              path="/application-group/:id/result"
              element={<GroupResult />}
            />
            <Route path="/application-group/:id/client" element={<Client />}>
              <Route
                path="/application-group/:id/client/:clientId/ocr"
                element={<GroupOcr />}
              />
              <Route
                path="/application-group/:id/client/:clientId/scoring"
                element={<GroupScoring />}
              />
            </Route>
          </Route>

          <Route
            path="/settings"
            element={user.role !== "expert" ? <Settings /> : <></>}
          />
          <Route
            path="/action-history"
            element={user.role !== "expert" ? <ActionHistory /> : <></>}
          />
          <Route
            path="/users"
            element={user.role !== "expert" ? <Users /> : <></>}
          />
          <Route path="*" element={<Navigate to="/" />} />
        </Route>
      </Routes>
    </Suspense>
  )
}

export default AppRoutes
